/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Image from "gatsby-image"

const Bio = ({date}) => {
  const data = useStaticQuery(graphql`
    query ImageQuery {
      avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
        childImageSharp {
          fixed(width: 50, height: 50) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  const { author} = data.site.siteMetadata
  return (
    <div className='written-by-container'>
    <div className='written-by-image'>
    <Image
        fixed={data.avatar.childImageSharp.fixed}
        alt={author.name}
      />
    </div>
    <p>
      Written by <b>Lenvin Gonsalves</b>.
      <br/>
      on {date}
    </p>
    </div>
  )
}

export default Bio
